module.exports = __webpack_public_path__ + "static/img/labour-4.ad409ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/labour-4.png
// module id = 3qEQ
// module chunks = 1